export default "__VITE_ASSET__DRUUe4Ta__"